/* ELLESANTI · tema V3 · le foto (02/10/2026, CTRL+G). Nessuna libreria.
   1 · Still life vecchie su bianco puro: prendono il fondo caldo delle still life nuove con un velo leggero, circa il 3%
       (filtro SVG che moltiplica R 0,973 · G 0,961 · B 0,945: il bianco diventa #F8F5F1; prima del 5/10 era #F3EEE8).
       Vale anche per le miniature dei colori sopra «Aggiungi al carrello» (.e-vt img) e per le foto del pre-carrello (5/10/2026). Si riconoscono leggendo
       i quattro angoli della foto in una copia di 48 px: solo se sono bianchi puri. Le nuove (angoli sui 249/243/238) e le
       ambientate non cambiano. Il risultato resta in sessionStorage per non rileggere le stesse foto.
   2 · «Fatta a mano» nella scheda: se le sezioni prima o dopo sono vuote (gioielli senza i dati del momento),
       la sezione prende lo spazio che le darebbero quelle sezioni, così non tocca «Vedi tutte le foto» né la sezione scura.
   3 · Lista dei desideri (Wishlist by Square, /apps/page/wishlist): numero dei gioielli nell'occhiello, invito con bottone
       quando la lista è vuota (fuori dal blocco dell'app) e foto prese dal dominio del negozio in 800 px, così il velo
       caldo delle still life funziona anche qui. */
(function () {
  'use strict';
  var SEL = '.Vtl-WishlistProduct__Image, .e-card img, .e-gal img, .e-vt img, .e-addp__i img, .e-pc__im img, .e-qv img, .e-ctl img, .e-sbar img, .e-mani img, .e-cs img, .e-rs img, .e-mc__ph img, .e-macc__ph img, .e-alt img, .e-pacc img';
  var KEY = 'e-sl1', cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { cache = {}; }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(cache)); } catch (e) {} }
  function filtro() {
    if (document.getElementById('e-sl-f')) return;
    var d = document.createElement('div');
    d.setAttribute('aria-hidden', 'true');
    d.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none';
    d.innerHTML = '<svg width="0" height="0" focusable="false"><filter id="e-sl-f" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0.973 0 0 0 0  0 0.961 0 0 0  0 0 0.945 0 0  0 0 0 1 0"/></filter></svg>';
    document.body.appendChild(d);
  }
  function segna(img) { filtro(); img.classList.add('e-sl-bianco'); }
  function prova(img) {
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('data:') === 0 || img._esl === src) return;
    img._esl = src;
    var u;
    try { u = new URL(src, location.href); } catch (e) { return; }
    if (u.origin !== location.origin || !/\/cdn\/shop\//.test(u.pathname) || /\.(svg|gif)$/i.test(u.pathname)) return;
    var b = u.pathname;
    if (cache[b] !== undefined) { img.classList.toggle('e-sl-bianco', !!cache[b]); if (cache[b]) filtro(); return; }
    u.searchParams.set('width', '48');
    var t = new Image();
    t.onload = function () {
      var w = 24, h = Math.max(2, Math.round(24 * t.naturalHeight / t.naturalWidth));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d');
      try {
        x.drawImage(t, 0, 0, w, h);
        var d = x.getImageData(0, 0, w, h).data, ok = true;
        [[0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1], [Math.floor(w / 2), 0]].forEach(function (p) {
          var k = (p[1] * w + p[0]) * 4;
          if (d[k] < 251 || d[k + 1] < 251 || d[k + 2] < 251 || d[k + 3] < 255) ok = false;
        });
        cache[b] = ok ? 1 : 0; save();
        if (ok) segna(img); else img.classList.remove('e-sl-bianco');
      } catch (e) {}
    };
    t.src = u.href;
  }
  function guarda(img) {
    if (img._eslOn) { if (img.complete) prova(img); return; }
    img._eslOn = true;
    img.addEventListener('load', function () { prova(img); });
    if (img.complete && img.naturalWidth) prova(img);
  }
  function scan(r) {
    if (!r || !r.querySelectorAll) return;
    if (r.matches && r.matches(SEL)) guarda(r);
    var l = r.querySelectorAll(SEL);
    for (var i = 0; i < l.length; i++) guarda(l[i]);
  }

  function mano() {
    var m = document.querySelector('.e-mano');
    if (!m) return;
    var s = m.closest('.shopify-section');
    if (!s) return;
    var vicina = function (x, avanti) {
      x = avanti ? x.nextElementSibling : x.previousElementSibling;
      while (x && !x.querySelector('*')) x = avanti ? x.nextElementSibling : x.previousElementSibling;
      return x;
    };
    var p = vicina(s, false), n = vicina(s, true);
    m.classList.toggle('e-mano--inizio', !!(p && p.querySelector('.e-pdp')));
    m.classList.toggle('e-mano--fine', !!(n && n.querySelector('.e-pend')));
  }

  var EN = /^en/i.test(document.documentElement.lang || '');
  function wlFoto(img) {
    var m = /^https:\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\/files\/(.+?)(?:_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*))?\.(jpe?g|png|webp)(?:\?v=(\d+))?$/i.exec(img.getAttribute('src') || '');
    if (!m) return;
    img.setAttribute('src', '/cdn/shop/files/' + m[1] + '.' + m[2] + '?' + (m[3] ? 'v=' + m[3] + '&' : '') + 'width=800');
  }
  function wl() {
    var c = document.querySelector('.vtl-proxy-page-wishlist');
    if (!c) return;
    var l = c.querySelectorAll('.Vtl-WishlistProduct__Image');
    for (var i = 0; i < l.length; i++) wlFoto(l[i]);
    var n = c.querySelectorAll('.Vtl-WishlistProduct').length;
    var t = n ? ' · ' + n + (EN ? (n === 1 ? ' piece' : ' pieces') : (n === 1 ? ' gioiello' : ' gioielli')) : '';
    if (c._wln !== t) { c._wln = t; c.style.setProperty('--e-wl-n', t ? '"' + t + '"' : '""'); }
    if (!c.nextElementSibling || !c.nextElementSibling.classList.contains('e-wl-vuota')) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var v = document.createElement('div');
      v.className = 'e-wl-vuota';
      v.innerHTML = '<p></p><a class="e-btn" href="' + root + 'collections/shop"></a>';
      v.querySelector('p').textContent = EN ? 'Tap the heart on a piece to keep it here. Come back to it whenever you like, or share the list with someone choosing a gift for you.' : 'Tocca il cuore su un gioiello per tenerlo qui. Puoi tornare a guardarlo quando vuoi, o condividere la lista con chi sta pensando a un regalo per te.';
      v.querySelector('a').textContent = EN ? 'Discover the jewellery' : 'Scopri i gioielli';
      c.parentNode.insertBefore(v, c.nextSibling);
    }
  }
  var wlT = 0;
  function wlPoi() { if (wlT) return; wlT = setTimeout(function () { wlT = 0; wl(); }, 60); }

  function avvia() {
    wl();
    scan(document);
    mano();
    if (window.MutationObserver) {
      new MutationObserver(function (ms) {
        if (document.querySelector('.vtl-proxy-page-wishlist')) wlPoi();
        ms.forEach(function (mu) {
          if (mu.type === 'attributes') { if (mu.target.matches && mu.target.matches(SEL)) guarda(mu.target); return; }
          for (var i = 0; i < mu.addedNodes.length; i++) if (mu.addedNodes[i].nodeType === 1) scan(mu.addedNodes[i]);
        });
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); mano(); });
})();
